<template>
  <div class="das_top_cont nc_root">
    <div class="history_box account_input">
      <div class="accountright_cont_box">
        <div class="flex_center_between_box">
          <div style="display:flex;">
            <h2 class="nc_root_header_title">
              <el-badge :value="RedNews.length" :hidden="RedNews.length == 0" class="item" type="success">
                {{ $t('AccountCenterMenu.Notifications') }}
              </el-badge>
            </h2>
            <div class="history_box-head-right flex_center">
              <svg t="1723168823188" class="icon nc_root_header_icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5443">
                <path
                  d="M921.6 512h-41l92.2 460.8c0 28.3-22.9 51.2-51.2 51.2H102.4c-28.3 0-51.2-22.9-51.2-51.2L143.4 512h-41c-28.3 0-51.2-22.9-51.2-51.2v-51.2c0-28.3 22.9-51.2 51.2-51.2h307.2v-256C409.6 45.8 455.4 0 512 0s102.4 45.8 102.4 102.4v256h307.2c28.3 0 51.2 22.9 51.2 51.2v51.2c0 28.3-22.9 51.2-51.2 51.2zM102.4 972.8h155.2c-3.7-5.5-5.2-12.1-4.1-18.6l31.2-227.6c1.9-14 14.8-23.8 28.8-21.9 14 1.9 23.8 14.8 21.9 28.8-0.1 0.6-0.2 1.3-0.3 1.9l-31 227.6c-0.6 3.5-1.9 6.8-3.9 9.7h621.4L819.2 512H204.8L102.4 972.8z m460.8-870.4c0-28.3-22.9-51.2-51.2-51.2s-51.2 22.9-51.2 51.2v256h102.4v-256z m358.4 307.2H102.4v51.2h819.2v-51.2z"
                  fill="#1A2332" p-id="5444"></path>
              </svg>
              <span class="cleara" @click="MarkRead()">{{ $t('navigationBar.MarkasRead') }} </span>

            </div>
          </div>
          <div class="sel_box computer_right_cont_box">
            <el-input autocomplete="off" class="inline-input" suffix-icon="el-icon-search" v-model="Contentval"
              placeholder="Enter Title Content" @change="NewInput()"></el-input>
            <!-- suffix-icon="el-icon-search" -->
          </div>
        </div>
        <div class="faq_box nc_root_con">
          <div class="">
            <el-collapse v-model="activeNames" @change="Changered" v-if="Newlist.length > 0">
              <!--  -->
              <el-collapse-item class="item_title" v-for="(item, index) in Newlist" :name="JSON.stringify(item)"
                :key="index">
                <template slot="title">
                  <div class="flex_center_between_box" style="width: 100%;">
                    <div class="flex_center_between_box">
                      <img src="../../../assets/img/csi头像.png" alt="" />
                      <div class="message-right">
                        <div class="head-text">{{ item.title }}</div>
                        <div class="icon-time">{{ item.createTime }}</div>
                      </div>
                    </div>
                    <div v-show="item.hasRead == 0" class="greea-cre"></div>
                  </div>
                </template>
                <div class="item_cont_txt">
                  {{ item.content }}
                </div>
              </el-collapse-item>
            </el-collapse>
            <img v-else
                :src='require("@/assets/images/empty.png")'
                class="detail-empty-img"
              />
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNotificationList, readNotification, markAllAsRead, searchByTitle } from '@/api/userApi.js';
export default {
  data() {
    return {
      activeNames: [1],
      attentionDialog: false, //弹框
      Contentval: "",
      RedNews: [],
      Newlist: [{
        logo: '',
        title: '',
        content: '',
        hasRead: '',
        createTime: ''

      }]
    };
  },
  computed: {},

  created() {
    this.getNotificationListDetali()
  },
  methods: {
    Changered(item) {

      this.$store.dispatch("app/SetNotificationsList", []);
      let arr = item
      if (arr.length > 1) {
        arr.splice(0, 1);

      }
      if (JSON.parse(arr).hasRead == 0) {
        readNotification({ id: JSON.parse(arr).id }).then(res => {
          if (res.code == 200) {
            this.getNotificationListDetali()
          }
        })
      }



    },
    NewInput() {
      searchByTitle({ titleKey: this.Contentval }).then(res => {
        if (res.code == 200) {
          this.Newlist = res.data


          if (this.Newlist.length > 0) {
            res.data.map(item => {
              if (item.hasRead == 0) {
                this.RedNews.push(item)
              }
            })
          }


        } else {
          this.Newlist = []
        }

      })

    },
    MarkRead() {
      markAllAsRead().then(res => {
        if (res.code == 200) {
          this.getNotificationListDetali()
        }
      })
    },

    getNotificationListDetali() {
      getNotificationList().then(res => {
        if (res.code == 200) {
          this.Newlist = res.data

          if (this.Newlist.length > 0) {
            this.RedNews = this.Newlist.filter(item => item.hasRead == 0)
            this.$store.dispatch("app/SetNotificationsList", this.RedNews);

          }
        } else {

          this.Newlist = []
        }

      })
    }
  },
};
</script>
<style scoped>
.title {
  font-family: 'Arial Bold';
  margin-top: 19px;
  margin-bottom: 18px;
}

.el-collapse {
  border: none !important;
}

.item_title /deep/ .el-collapse-item__header {
  font-size: 14px;
  color: #022955;
  /* margin: 0.7142857142857143rem 0; */
  height: auto !important;
  background-color: #f5f5f5;
  border: none !important;
}

.item_title {
  padding: 20px;
  background-color: #f5f5f5;
  margin-bottom: 10px;
}

.item_title.el-collapse-item.is-active:last-child /deep/ .el-collapse-item__wrap,
.item_title:last-child /deep/ .el-collapse-item__header {
  border-width: 0;
  border: none !important;
}

.item_title /deep/ .el-collapse-item__header.is-active {
  border-bottom-color: transparent;
}

.item_cont_title {


  /* margin-bottom: 0.7142857142857143rem; */
  color: #022955;
}

.item_cont_txt {
  padding-top: 8px;
  padding-left: 70px;
  /* height: 1.5714285714285714rem; */
  /* padding-left: 5rem; */
  background-color: #f5f5f5;
  /* padding-top: 1.1428571428571428rem; */
  font-family: 'Arial';
  font-size: 18px;
  color: #1A2332;
  line-height: 26px;
  text-align: left;
  font-style: normal;
}

.title_txt img {
  width: 18px;
  margin-right: 7px;
}

.item_title /deep/.el-collapse-item__content {
  padding-bottom: 0;
}

/* .item_title /deep/ .el-collapse-item__arrow {
    width: 1.7142857142857142rem;
    height: 1.7142857142857142rem;
    background: #ffffff;
    border-radius: 0.5714285714285714rem;
    border: 0.07142857142857142rem solid #e7eaed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 0.6428571428571429rem;
} */
/* .item_title /deep/ .el-collapse-item__arrow::before {
    content: '';
}
*/
.item_title /deep/ .el-collapse-item__arrow {
  margin-right: 0;
  transform: rotate(90deg);
}

.item_title /deep/ .el-collapse-item__arrow.is-active {
  transform: rotate(-90deg);
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.link {
  color: #1290c9;
  text-decoration: underline;
}

.head-text {
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 20px;
  color: #1A2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}

.icon-time {
  height: 20px;
  margin-top: 8px;
  font-family: 'Arial';
  font-size: 16px;
  color: #999999;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}

.message-right {
  margin-left: 20px;
}

.account_input .sel_box {
  width: 335px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #CCCCCC;
}

.sel_box /deep/ .el-input__inner {
  border: none;
  font-size: 16px;
  line-height: 38px;
}

/deep/ .el-badge__content--success {
  background-color: #55B419;
  top: 14px !important;
  right: -10px !important;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  font-size: 16px;
  padding: 0rem !important;
  line-height: 24px;
}

.cleara {
  margin-left: 8px;
  margin-top: 2px;
  cursor: pointer;
  font-family: 'Arial';
  font-size: 16px;
  color: #1A2332;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
}

.history_box-head-right {
  margin-left: 66px;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}

.greea-cre {
  width: 12px;
  height: 12px;
  margin-right: 12px;
  background: #55B419;
  border-radius: 50%;
  /* position: relative;
  top: -1.5rem;
  left: -0.6428571428571429rem; */
}

/* 特殊处理 */
.account_input .sel_box {
  margin-right: 0;
}

.account_input .accountright_cont_box .flex_center_between_box {
  margin-bottom: 0;
}

.el-input .el-icon-search:before {
  width: 14px;
  height: 14px;
  background: #1A2332;
}

.createTimeColor {
  margin-left: 10px;
  font-size: 14px;
}

.accountright_cont_box {
  min-height: calc(100vh - 152px);
}

.nc_root_header_title div {
  font-family: 'Arial Bold';
  font-weight: normal;
  font-size: 24px;
  color: #1290c9;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.nc_root_header_icon {
  width: 18px;
  height: 18px;
}

.nc_root_con {
  margin-top: 20px;
}

.nc_root_con img {
  width: 50px;
  height: 50px;
}

.detail-empty-img{
  display: block;
  width: 722px !important;
  height: 406px !important;
  margin: 100px auto;
}

.computer_right_cont_box ::v-deep input::-webkit-input-placeholder {
  color: #ccc !important; 
}

@media screen and (max-width: 1920px) {
  .title {
    margin-top: 15px;
    margin-bottom: 14px;
  }

  .item_title /deep/ .el-collapse-item__header {
    font-size: 12px;
  }

  .item_title {
    padding: 20px;
    margin-bottom: 7px;
  }

  .item_cont_txt {
    padding-top: 6px;
    padding-left: 52px;
    font-size: 16px;
    line-height: 20px;
  }

  .title_txt img {
    width: 14px;
    margin-right: 5px;
  }

  .head-text {
    font-size: 16px;
    line-height: 18px;
  }

  .icon-time {
    height: 18px;
    margin-top: 6px;
    font-size: 16px;
    line-height: 18px;
  }

  .message-right {
    margin-left: 15px;
  }

  .account_input .sel_box {
    width: 252px;
    height: 36px;
    border-radius: 7px;
  }

  .sel_box /deep/ .el-input__inner {
    font-size: 14px;
    line-height: 34px;
  }

  ::v-deep .el-badge__content--success {
    top: 20px !important;
    right: -7px !important;
    height: 20px;
    width: 20px;
    font-size: 14px;
    line-height: 18px;
  }

  .cleara {
    margin-left: 6px;
    font-size: 14px;
    line-height: 22px;
  }

  .history_box-head-right {
    height: 40px;
    margin-left: 50px;
  }

  .greea-cre {
    width: 9px;
    height: 9px;
    margin-right: 9px;
  }

  .el-input .el-icon-search:before {
    width: 12px;
    height: 12px;
  }

  .createTimeColor {
    margin-left: 7px;
    font-size: 12px;
  }

  .accountright_cont_box {
    min-height: calc(100vh - 136px);
  }

  .nc_root_header_title div {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
  }

  .nc_root_header_icon {
    width: 14px;
    height: 14px;
  }

  .nc_root_con {
    margin-top: 15px;
  }

  .nc_root_con img {
    width: 38px;
    height: 38px;
  }
  
  .detail-empty-img{
    width: 540px !important;
    height: 300px !important;
    margin: 75px auto;
  }
}

@media screen and (max-width: 1439px) {
  .title {
    margin-top: 13px;
    margin-bottom: 12px;
  }

  .item_title /deep/ .el-collapse-item__header {
    font-size: 12px;
  }

  .item_title {
    padding: 12px;
    margin-bottom: 6px;
  }

  .item_cont_txt {
    padding-top: 5px;
    padding-left: 44px;
    font-size: 14px;
    line-height: 18px;
  }

  .title_txt img {
    width: 12px;
    margin-right: 5px;
  }

  .head-text {
    font-size: 12px;
    line-height: 16px;
  }

  .icon-time {
    height: 12px;
    margin-top: 5px;
    font-size: 12px;
    line-height: 14px;
  }

  .message-right {
    margin-left: 12px;
  }

  .sel_box /deep/ .el-input__inner {
    font-size: 12px;
    line-height: 24px;
  }

  ::v-deep .el-badge__content--success {
    top: 9px !important;
    right: -6px !important;
    height: 18px;
    width: 18px;
    font-size: 12px;
    line-height: 16px;
  }

  .cleara {
    margin-left: 5px;
    font-size: 12px;
    line-height: 18px;
  }

  .history_box-head-right {
    margin-left: 44px;
  }

  .greea-cre {
    width: 8px;
    height: 8px;
    margin-right: 8px;
  }

  .el-input .el-icon-search:before {
    width: 9px;
    height: 9px;
  }

  .createTimeColor {
    margin-left: 6px;
    font-size: 12px;
  }

  .accountright_cont_box {
    min-height: calc(100vh - 126px);
  }

  .nc_root_header_title div {
    font-size: 16px;
  }

  .nc_root_header_icon {
    width: 12px;
    height: 12px;
  }

  .nc_root_con {
    margin-top: 12px;
  }

  .nc_root_con img {
    width: 32px;
    height: 32px;
  }

  .account_input .sel_box {
    width: 226px;
    height: 26px;
    border-radius: 6px;
  }
  
  .detail-empty-img{
    width: 480px !important;
    height: 270px !important;
    margin: 70px auto;
  }
}
</style>